export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/lensGreenIcon.4dd5d8d5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};